import React from 'react';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import {
  appointmentsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  CalendarEvent,
} from 'pages/Dashboard/pages/Appointments/pages/List/types/appointment';
import {
  Button,
} from 'pages/Dashboard/components/Button';

type Props = {
  appointment?: CalendarEvent;
};

export default function PatientCommunication({ appointment }: Props) {
  const onSend = () => {
    appointmentsEventChannel.emit('onAppointmentConfirmation', {
      appointment,
      selectedAction: {
        title: 'Send Appointment Reminder',
        optionText: 'Appointment Reminder',
        showFormSelect: true,
        allowFormSelect: true,
        showSendModeSelect: true,
        prefillContact: true,
        communiqueType: 'AppointmentReminder',
      },
    });
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        className="!border-secondary disabled:!border-gray-300 !px-2.5 !py-0.5 !min-w-[120px]"
        variant="outlined"
        type="button"
        color="primary"
        onClick={onSend}
        size="small"
        startIcon={<SendRoundedIcon className="!h-4 !w-4" />}
      >
        Send Reminder
      </Button>
    </div>
  );
}
